var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
import * as React from 'react';
import { useState } from 'react';
import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, TextField, } from '@fluentui/react';
/**
 * Reject-reason dialog (F4) — parity of the GRM reject flow which requires a decline reason
 * (`DenyOOFComments` / validateRejectFormDetail) before rejecting a pending event.
 */
export const RejectReasonDialog = ({ hidden, eventLabel, onConfirm, onDismiss, }) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState(undefined);
    const confirm = () => {
        if (!reason.trim()) {
            setError('Please enter a reason for rejection');
            return;
        }
        onConfirm(reason.trim());
        setReason('');
        setError(undefined);
    };
    const dismiss = () => {
        setReason('');
        setError(undefined);
        onDismiss();
    };
    return (React.createElement(Dialog, { hidden: hidden, onDismiss: dismiss, dialogContentProps: {
            type: DialogType.normal,
            title: 'Reject event',
            subText: eventLabel,
        } },
        React.createElement(TextField, { label: "Reason", multiline: true, required: true, value: reason, errorMessage: error, onChange: (_e, v) => setReason(v !== null && v !== void 0 ? v : '') }),
        React.createElement(DialogFooter, null,
            React.createElement(PrimaryButton, { text: "Reject", onClick: confirm }),
            React.createElement(DefaultButton, { text: "Cancel", onClick: dismiss }))));
};
export default RejectReasonDialog;
//# sourceMappingURL=RejectReasonDialog.js.map